<template>
  <action-dialog :value="value" @input="$emit('input', $event)" @close="$emit('input', !value)" @confirm="createProdCom"
                 title="Create producer commission" max-width="400" bottom-divider :disabled="!valid">
    <producer-commission-form ref="prodComForm" @valid="(v) => valid = v"></producer-commission-form>
    <loading-overlay v-model="loading" absolute></loading-overlay>
  </action-dialog>
</template>

<script>
  import ActionDialog from "../../ActionDialog";
  import ProducerCommissionForm from "./forms/ProducerCommissionForm";
  import LoadingOverlay from "../../LoadingOverlay";
  export default {
    name: "CreateProducerCommissionDialog",
    components: {LoadingOverlay, ProducerCommissionForm, ActionDialog},
    props: {
      value: {
        required: true,
        type: Boolean
      }
    },
    data: () => ({
      loading: false,
      valid: false
    }),
    methods: {
      createProdCom() {
        this.loading = true;
        this.$refs.prodComForm.createProdCom()
          .then(() => {
            this.loading = false;
            this.$emit('input', !this.value);
            this.$emit('created');
          })
      }
    }
  }
</script>

<style scoped>

</style>